<template>
    <div class="edit-order">
        <h2 class="edit-order-header">Edit Order</h2>

        <b-row class="form-row" align-h="center" align-v="center">
            <b-col cols="10" sm="10">
                <p>{{ previousNotes }}</p>
            </b-col>
        </b-row>

        <b-row class="form-row" align-h="center" align-v="center">
                <b-col cols="4" sm="3">
                    <label for="note">Notes</label>
                </b-col>
                <b-col cols="8" sm="9">
                    <b-form-textarea id="note" v-model="notes"></b-form-textarea>
                </b-col>
            </b-row>

            <b-row class="mt-4" align-h="center" align-v="center">
                <b-col cols="3" sm="3" md="3" lg="4">
                    <b-btn class="form-btn submit-btn" @click="submitEditOrder">Edit</b-btn>
                </b-col>
                <b-col cols="3" sm="3" md="3" lg="4">
                    <b-btn class="form-btn cancel-btn" @click="cancelEdit">Cancel</b-btn>
                </b-col>
            </b-row>

            <div class="loader" v-if="loader">
                <Loader/>
            </div>
    </div>

</template>

<script>
import Loader from "../../../components/Loader"
import axios from 'axios'
export default {
    components: {
        Loader
    },
    props: {
        submitEdit: Function,
        cancelEdit: Function,
        previousNotes: String,
        editOrderItem: Object

    },
    data() {
        return {
            notes: '',
            editOrderApi: 'https://us-central1-readytextme.cloudfunctions.net/editNotes',
            loader: false
        }
    },
    methods: {
        async submitEditOrder () {
        // method to edit order
      console.log('editing order');

      const obj = {
        'business': this.editOrderItem.business,
        'phone': this.editOrderItem.phone_number,
        'startTime': this.editOrderItem.startTime,
        'notes': this.notes
      }

    //   console.log(obj);
    // request api to edit order
      try {
        this.loader = true;
        await axios.post(
        this.editOrderApi,
        obj,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        this.$parent.editOrder = false;
        this.loader = false;
        console.log('order edited');
      } catch (error) {
          console.log(error);
          this.loader = false;
      }
    },
    },
}
</script>

<style scoped>
.edit-order {
    padding: 0 40px;
}

.edit-order-header {
    /* color: #ffffff; */
    padding-bottom: 20px;
}

.loader {
    position: fixed;
    width: 350px;
    height: 350px;
    z-index: 100;
    margin-top: 40px;
    padding-top: 70px;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #c0c0c0;
    border-radius: 3px;
    transition: all 0.8s ease;
    }
</style>
